<ul #hostList [class]="ulClass">
  <ng-content></ng-content>
  <div class="placeholder" [class.out]="!isRevealed">
    <div class="placeholder-line"></div>
    <div class="placeholder-line"></div>
    <div class="placeholder-line"></div>
  </div>
</ul>
